// src/components/layout/ChatColumn/MessageSkeleton.jsx
import React, { useMemo } from 'react';

const MessageSkeleton = ({ role }) => {
  const isUser = role === 'user';
  
  // Randomize width for a more organic look
  const randomWidth = useMemo(() => {
    return Math.floor(Math.random() * (75 - 40 + 1)) + 40; // width between 40% and 75%
  }, []);

  return (
    <div className={`w-full flex items-end mb-4 mt-2 ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div 
        className="animate-pulse rounded-2xl bg-gray-700/40"
        style={{ 
          width: `${randomWidth}%`,
          height: '60px' // A consistent height for skeletons is often visually cleaner
        }}
      />
    </div>
  );
};

export default React.memo(MessageSkeleton);